<template>
  <v-form ref="form" @submit.prevent="update">
    <v-text-field
      v-model="name"
      label="Full Name"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="ssn"
      label="Social Security Number"
      :rules="[required]"
      mask="social"
      validate-on-blur
    />
    <v-text-field
      v-model="phone"
      label="Phone Number"
      :rules="[required]"
      mask="phone"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.type"
      label="Type of Bank Account"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.routing"
      label="Bank Account Routing Number"
      :rules="[required]"
      validate-on-blur
    />
    <v-text-field
      v-model="bank.number"
      label="Bank Account Number"
      :rules="[required]"
      validate-on-blur
    />
    <v-btn type="submit" :loading="isLoading" :color="buttonStatus">
      Update
    </v-btn>
  </v-form>
</template>

<script>
import { pick } from 'lodash-es';
import { db, getUid } from '@/plugins/firebase';
import { required } from '@/util';

const userRef = db.collection('users').doc(getUid());

export default {
  data: () => ({
    isLoading: false,
    buttonStatus: 'primary',
    ssn: null,
    name: null,
    phone: null,
    bank: {
      type: null,
      routing: null,
      number: null,
    },
  }),
  async created() {
    const details = (await userRef.get()).data();
    Object.assign(this, details);
  },
  methods: {
    required,
    async update() {
      if (!this.$refs.form.validate()) return;
      this.isLoading = true;
      await userRef.update(pick(this, ['bank', 'name', 'ssn', 'phone']));
      this.isLoading = false;
      this.buttonStatus = 'success';
    },
  },
};
</script>

<style></style>
